<template>
  <div class="select-box">
    <div class="select-input">
      <input ref="selectInputEle" id="select-input-ele" class="select-input-ele" @input="handleInput" />
    </div>
    <div class="selection-options mt10">
      <div
        v-for="item in filterOptions"
        class="option-item"
        :key="item.name"
        :class="{ selected: item.name === value, 'row-flat': !layFlat }"
        @click="handleSelect(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <!-- <button @click="focusInput">按钮</button> -->
  </div>
</template>
<script setup lang="ts">
import { debounce } from 'lodash'
import { computed, onMounted, ref, nextTick } from 'vue'
import { useGarageStore } from '@/store/garage'

const garageStore = useGarageStore()
const isPC = computed(() => (garageStore.client === 'pc'))
const props = defineProps({
  options: {
    type: Array,
    default: () => []
  },
  value: {
    type: String,
    default: ''
  },
  layFlat: {
    type: Boolean,
    default: false
  }
})

const selectInputEle = ref()

const emit = defineEmits(['update:value', 'select'])

const filterKey = ref('')

const filterOptions = computed(() => {
  return props.options?.filter(
    (e: any) => e.name?.toLowerCase()?.indexOf(filterKey.value?.toLowerCase()) > -1
  )
})

const handleSelect = (item) => {
  emit('update:value', item.name)
  emit('select', item.name)
}

const handleInput = debounce((e) => {
  filterKey.value = e.target.value
}, 1000)

const focusInput = () => {
  console.log('selectInputEle.value', selectInputEle.value)
  selectInputEle.value.focus()
}

onMounted(() => {
  if (isPC.value) {
    setTimeout(() => {
      focusInput()
    }, 1000)
  }
})

</script>
<style lang="scss" scoped>
.select-box {
  position: relative;
  width: 100%;
  height: 100%;
  .select-input {
    width: 100%;
    height: 100%;
    min-height: 40px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    font-size: 16px;
    .select-input-ele {
      width: 100%;
      border: none;
    }
  }
  .selection-options {
    display: flex;
    flex-wrap: wrap;
    height: 70vh;
    overflow-y: auto;
    align-content: flex-start;
    .option-item {
      &.row-flat {
        width: 100%;
        text-align: left;
        padding: 0 20px;
        line-height: 22px;
      }
      &.selected {
        color: #fdbb2b;
      }
      width: 33%;
      font-size: 16px;
      text-align: center;
      margin-top: 10px;
      height: 40px;
      line-height: 40px;
    }
  }

  .placeholder {
    font-size: 16px;
    color: #ccc;
  }
}
</style>
